/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		6: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
/******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
/******/ 	jsonpArray.push = webpackJsonpCallback;
/******/ 	jsonpArray = jsonpArray.slice();
/******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
/******/ 	var parentJsonpFunction = oldJsonpFunction;
/******/
/******/
/******/ 	// add entry module to deferred list
/******/ 	deferredModules.push([423,1,0]);
/******/ 	// run deferred modules when ready
/******/ 	return checkDeferredModules();
/******/ })
/************************************************************************/
/******/ ({

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
module.exports = __webpack_require__(463);


/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__(9);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(10);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__(43);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__(26);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__(39);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__(50);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(4);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(12);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(1);

// EXTERNAL MODULE: ./resources/constants/liquid-data.js
var liquid_data = __webpack_require__(2);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Customer/OrderList.vue?vue&type=template&id=0f79392c
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "grid" }, [
    _c("div", { staticClass: "grid__item medium-up--two-thirds" }, [
      _c(
        "div",
        { staticClass: "orders-list" },
        [
          _c(
            "div",
            { staticClass: "orders-list__title" },
            _vm._l(_vm.titles, function(title, key, index) {
              return _c("div", {
                key: title + "-" + index,
                class: key.toLowerCase(),
                domProps: { textContent: _vm._s(title) }
              })
            }),
            0
          ),
          _vm._v(" "),
          _vm._l(_vm.orderItems, function(item, index) {
            return _c(
              "div",
              { key: "item" + index, staticClass: "orders-list__item" },
              [
                _c("div", { staticClass: "orders-list__item--image" }, [
                  _c("img", { attrs: { src: item.product.image.src } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "orders-list__info" }, [
                  _c(
                    "div",
                    { staticClass: "orders-list__item--product" },
                    [
                      _c("a", { attrs: { href: item.url } }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.title) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      item.fulfillment
                        ? _c("div", {
                            staticClass: "fulfillment",
                            domProps: {
                              textContent: _vm._s(
                                "Traitée"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("template", { slot: "popover" }, [
                        _c("span", [_vm._v("Link copied!")])
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "orders-list__item--price",
                    attrs: { "data-title": _vm.titles.price + ": " },
                    domProps: { textContent: _vm._s(_vm.money(item.price)) }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "orders-list__item--quantity",
                    attrs: { "data-title": _vm.titles.quantity + ": " },
                    domProps: { textContent: _vm._s(item.quantity) }
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "orders-list__item--subtotal",
                    attrs: { "data-title": _vm.titles.total + ": " },
                    domProps: {
                      textContent: _vm._s(
                        _vm.money(item.price * 100 * item.quantity)
                      )
                    }
                  })
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "orders-list__sum" }, [
        _c("div", { staticClass: "orders-list__sum--subtotal" }, [
          _c("div", [_vm._v(_vm._s(_vm._f("t")("customer.order.subtotal")))]),
          _vm._v(" "),
          _c("div", {
            domProps: {
              textContent: _vm._s(_vm.money(_vm.order.subtotal_price))
            }
          })
        ]),
        _vm._v(" "),
        _vm.order.discounts
          ? _c(
              "div",
              { staticClass: "orders-list__sum--discount" },
              [
                _c("div", [
                  _vm._v(_vm._s(_vm._f("t")("customer.order.discount")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.order.discounts, function(discount, index) {
                  return _c("span", {
                    key: "discounts" + index,
                    domProps: {
                      textContent: _vm._s(_vm.money(discount.savings))
                    }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.order.shipping_methods
          ? _c(
              "div",
              { staticClass: "orders-list__sum--shipping" },
              [
                _c("div", [
                  _vm._v(_vm._s(_vm._f("t")("customer.order.shipping")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.order.shipping_methods, function(shipping, index) {
                  return _c("div", {
                    key: "discounts" + index,
                    domProps: { textContent: _vm._s(_vm.money(shipping.price)) }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "orders-list__sum--total" }, [
          _c("div", [_vm._v(_vm._s(_vm._f("t")("customer.order.total")))]),
          _vm._v(" "),
          _c("div", {
            domProps: { textContent: _vm._s(_vm.money(_vm.order.total_price)) }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "order-address grid__item medium-up--one-third" },
      [
        _c("div", [
          _c("h3", [
            _vm._v(_vm._s(_vm._f("t")("customer.order.billing_address")))
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(_vm._s(_vm._f("t")("customer.order.payment_status")) + ":")
            ]),
            _vm._v(" " + _vm._s(_vm.order.financial_status_label))
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: { innerHTML: _vm._s(_vm.order.billing_address_format) }
          })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("h3", [
            _vm._v(_vm._s(_vm._f("t")("customer.order.shipping_address")))
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(
                _vm._s(_vm._f("t")("customer.order.fulfillment_status")) + ":"
              )
            ]),
            _vm._v(" " + _vm._s(_vm.order.fulfillment_status_label))
          ]),
          _vm._v(" "),
          _c("p", {
            domProps: { innerHTML: _vm._s(_vm.order.shipping_address_format) }
          })
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./resources/components/Customer/OrderList.vue?vue&type=template&id=0f79392c

// EXTERNAL MODULE: ./resources/utils/shopify.js
var shopify = __webpack_require__(17);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Customer/OrderList.vue?vue&type=script&lang=js
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var OrderListvue_type_script_lang_js = ({
  name: 'OrderList',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      orderItems: this.order.line_items,
      titles: {
        image: "Produit",
        product: '',
        price: "Prix",
        quantity: "Quantité",
        total: "Total"
      }
    };
  },
  methods: {
    money: function money(price) {
      return shopify["a" /* formatMoney */](price, shopify["b" /* money_format */]);
    }
  }
});
// CONCATENATED MODULE: ./resources/components/Customer/OrderList.vue?vue&type=script&lang=js
 /* harmony default export */ var Customer_OrderListvue_type_script_lang_js = (OrderListvue_type_script_lang_js); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(3);

// CONCATENATED MODULE: ./resources/components/Customer/OrderList.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  Customer_OrderListvue_type_script_lang_js,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "resources/components/Customer/OrderList.vue"
/* harmony default export */ var OrderList = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Customer/Order.vue?vue&type=template&id=e9b10324
var Ordervue_type_template_id_e9b10324_render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order" }, [
    _c("div", { staticClass: "section-header text-center" }, [
      _c("h1", [_vm._v(_vm._s(_vm._f("t")("customer.account.title")))]),
      _vm._v(" "),
      _c("p", [
        _c("a", { attrs: { href: "/account" } }, [
          _vm._v(_vm._s(_vm._f("t")("customer.account.return")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid" }, [
      _c("div", { staticClass: "grid__item medium-up--two-thirds" }, [
        _c("h2", [
          _vm._v(
            _vm._s(_vm._f("t")("customer.order.title")) + _vm._s(_vm.order.name)
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm._f("t")("customer.order.date")) +
              " " +
              _vm._s(_vm.order.created_at)
          )
        ]),
        _vm._v(" "),
        _vm.order.cencelled
          ? _c("div", { staticClass: "order--cancelled" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm._f("t")("customer.order.cancelled")) +
                    " " +
                    _vm._s(_vm.order.cancelled_at)
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(_vm._f("t")("customer.order.cancelled_reason")) +
                    " " +
                    _vm._s(_vm.order.cancel_reason)
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "p",
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("t")("customer.order.tracking_number")) +
                ":\n        "
            ),
            _vm._l(_vm.orderItems, function(item, i) {
              return [
                item.fulfillment &&
                (i === 0 ||
                  _vm.orderItems[i - 1].fulfillment.tracking_number !=
                    item.fulfillment.tracking_number)
                  ? _c("a", {
                      key: "tracking" + i,
                      attrs: { href: item.fulfillment.tracking_url },
                      domProps: {
                        textContent: _vm._s(item.fulfillment.tracking_number)
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { key: "space" + i })
              ]
            })
          ],
          2
        )
      ])
    ])
  ])
}
var Ordervue_type_template_id_e9b10324_staticRenderFns = []
Ordervue_type_template_id_e9b10324_render._withStripped = true


// CONCATENATED MODULE: ./resources/components/Customer/Order.vue?vue&type=template&id=e9b10324

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./resources/components/Customer/Order.vue?vue&type=script&lang=js
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Ordervue_type_script_lang_js = ({
  name: 'Order',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      orderItems: this.order.line_items
    };
  }
});
// CONCATENATED MODULE: ./resources/components/Customer/Order.vue?vue&type=script&lang=js
 /* harmony default export */ var Customer_Ordervue_type_script_lang_js = (Ordervue_type_script_lang_js); 
// CONCATENATED MODULE: ./resources/components/Customer/Order.vue





/* normalize component */

var Order_component = Object(componentNormalizer["a" /* default */])(
  Customer_Ordervue_type_script_lang_js,
  Ordervue_type_template_id_e9b10324_render,
  Ordervue_type_template_id_e9b10324_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var Order_api; }
Order_component.options.__file = "resources/components/Customer/Order.vue"
/* harmony default export */ var Order = (Order_component.exports);
// CONCATENATED MODULE: ./resources/components/Customer/index.js


// EXTERNAL MODULE: ./node_modules/flatpickr/dist/flatpickr.js
var flatpickr = __webpack_require__(146);
var flatpickr_default = /*#__PURE__*/__webpack_require__.n(flatpickr);

// EXTERNAL MODULE: ./node_modules/flatpickr/dist/flatpickr.css
var dist_flatpickr = __webpack_require__(424);

// EXTERNAL MODULE: ./resources/styles/pages/customers.scss
var customers = __webpack_require__(426);

// EXTERNAL MODULE: ./resources/styles/pages/order.scss
var pages_order = __webpack_require__(206);

// CONCATENATED MODULE: ./resources/pages/customers.js







var _this = undefined;

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }











if (liquid_data["a" /* default */].template.includes('account')) {
  new vue_esm["default"]({
    el: '.account-editor',
    data: function data() {
      return {
        email: window.account.user,
        birthday: '',
        birthdayMonth: '',
        gender: '',
        backendDomain: window.Shopify.shop.replace('.myshopify.com', ''),
        editable: true,
        isSuccess: false
      };
    },
    computed: {
      tags: function tags() {
        var birthday = this.birthday,
            birthdayMonth = this.birthdayMonth,
            gender = this.gender;
        return "".concat(birthday, ",").concat(birthdayMonth, ",").concat(gender);
      }
    },
    mounted: function mounted() {
      var birthday = '';
      var month = '';
      var vueData = this;
      flatpickr_default()('#birthdaySelector', {
        dateFormat: 'Y-m-d',
        maxDate: '2012-12-31',
        minDate: '1920-01-01',
        onChange: function onChange(dObj, dStr, fun) {
          birthday = 'Birthday:' + jquery_default()('#birthdaySelector').val();
          month = 'Month:' + dStr.split('-')[1];
          vueData.birthday = birthday;
          vueData.birthdayMonth = month;
        }
      });
    },
    methods: {
      submit: function () {
        var _submit = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(e) {
          var email, tags;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  e.preventDefault();
                  email = this.email, tags = this.tags;
                  console.log(tags);
                  _context.next = 5;
                  return axios_default.a.post('https://ressource.rhinoshield.io/customer/preorder', {
                    email: email,
                    tags: tags
                  }, {
                    headers: {
                      'X-RH-API-ORIGIN': this.backendDomain
                    }
                  }).then(function (res) {
                    if (res.status === 200) document.location.reload();
                  }).catch(function (error) {
                    console.log('error', error);
                  });

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function submit(_x) {
          return _submit.apply(this, arguments);
        };
      }()
    }
  });
} else if (liquid_data["a" /* default */].template.includes('order')) {
  new vue_esm["default"]({
    el: '.order-status',
    components: {
      Order: Order,
      OrderList: OrderList
    },
    data: function data() {
      var order = liquid_data["a" /* default */].order;
      return {
        order: order // orderItems: order.line_items

      };
    },
    computed: {},
    methods: {}
  });
} else {
  var customers_birthday = '';
  var customers_month = '';
  var gender = '';
  flatpickr_default()('#birthdaySelector', {
    dateFormat: 'Y-m-d',
    maxDate: '2012-12-31',
    minDate: '1920-01-01',
    onChange: function onChange(dObj, dStr, fun) {
      customers_birthday = 'Birthday:' + jquery_default()('#birthdaySelector').val();
      customers_month = 'Month:' + dStr.split('-')[1];
      jquery_default()('#birthday').val(customers_birthday);
      jquery_default()('#birthMonth').val(customers_month);
      jquery_default()('#values').val(customers_birthday + ',' + customers_month + ',' + gender);
    }
  });
  jquery_default()('.edit form').submit(function () {
    gender = jquery_default()('input[name=gender]:checked').val();
    jquery_default()('#values').val(customers_birthday + ',' + customers_month + ',' + gender);
    jquery_default()(_this).submit();
  });
}

/***/ })

/******/ });